import React from "react";

const Section2 = ({
    onChange,
    onAddRow,
    onRemoveRow,
    monthly_report_hse_item
}) => {
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-12 ">
                    <div className="appraisal-report-table-responsive">
                        <table className="assessment-table" cellSpacing={0}>
                            <tbody>
                                {/* Title */}
                                <tr>
                                    <td className="hd-s2" colSpan={4}>
                                        <p>7.　HSE related items


                                        </p>
                                    </td>
                                </tr>


                                {/* Dynamic Rows */}
                                <tr >
                                    <td className="td-s1 text-center">#</td>

                                    <td className="td-s1">
                                        <p className="s1">Remark</p>
                                    </td>
                                    <td className="td-s1">
                                        <p className="s1">Action
                                        </p>
                                    </td>

                                </tr>
                                {/* Dynamic Rows */}
                                {monthly_report_hse_item.map((row, index) => (
                                    <tr key={index}>
                                        <td className="td-s1 text-center">{index + 1}</td>

                                        {/* Steel Cutting */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Remark "
                                                name="remark"
                                                value={row.remark.value}
                                                onChange={(e) => onChange(e, index)}
                                            />
                                        </td>


                                        {/* Remove Row */}
                                        <td className="tb-input-value text-center">
                                            <button
                                                type="button"
                                                style={{
                                                    backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                    borderColor: "#2b5a7e"
                                                }}
                                                className="btn btn-danger btn-sm"
                                                onClick={() => onRemoveRow(index)}
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))}

                                {/* Add Row */}
                                <tr>
                                    <td colSpan={10}>
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm ms-2"
                                            style={{
                                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                borderColor: "#2b5a7e"
                                            }}
                                            onClick={onAddRow}
                                        >
                                            + Add Row
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Section2;
